import axios from "axios";
import { useMutation } from "@tanstack/react-query";

import { Keys } from "client/api/_keys";
import { Routes } from "client/api/_routes";

import { onInsertMobileResponse } from "./helper";

const insertMobile = async (data: InsertMobileReqT) =>
  axios.post(Routes.INSERT_MOBILE, data);

export const useInsertMobile = () => {
  return useMutation({
    mutationKey: [Keys.INSERT_MOBILE_MUT],
    mutationFn: insertMobile,
    onSuccess: onInsertMobileResponse,
  });
};
